import dayjs from 'dayjs';
import {shallowRef, triggerRef, watch, type WatchSource} from 'vue';
import {storeToRefs} from 'pinia';
import {useLocaleStore} from '../../stores/localeStore';
import {createGlobalState} from '@vueuse/core';
import {type ValidLocale} from '@deskly/shared-ui/types';
// TODO Find a way to import locales just-in-time when they are needed
// Currently, they need to be available from the start, as otherwise
// dates will always have the locale 'en'
import de from 'dayjs/locale/de';
import en from 'dayjs/locale/en-gb';
import es from 'dayjs/locale/es';
import it from 'dayjs/locale/it';
import fr from 'dayjs/locale/fr';

export const useDayjsState = createGlobalState(() => {
    const {currentLocale} = storeToRefs(useLocaleStore());

    const reactiveDayjs = shallowRef(dayjs);

    useDayJsLocaleWatcher(currentLocale);

    function useDayJsLocaleWatcher(locale: WatchSource<ValidLocale>) {
        const importMap = {
            de,
            en,
            es,
            it,
            fr,
        };

        watch(
            locale,
            locale => {
                const localeImport = importMap[locale];
                if (!localeImport) {
                    return;
                }

                dayjs.locale(localeImport as ILocale);
                triggerRef(reactiveDayjs);
            },
            {immediate: true}
        );
    }

    return {reactiveDayjs};
});
